"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowIconSvg = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Styled = styled_components_1.default.span `
	display: inline-block;
	position: ${(p) => (p.relative ? "relative" : "absolute")};
	padding: 3px;

	transition: transform 0.2s ${(p) => p.theme.easing};

	svg path {
		transition: fill 0.2s ${(p) => p.theme.easing};
		fill: ${(p) => p.theme.palette.text.primary};
	}

	svg {
		height: 14px;
		width: 14px;
	}

	&:hover {
		transform: translate3d(0, 0, 0)
			translateX(${(p) => p.hoverDirection && (p.hoverDirection === "right" ? "4px" : "-4px")});
	}

	&.left {
		svg {
			transform: translate3d(0, 0, 0) rotate(-90deg);
		}
	}
	&.up {
		svg {
			transform: translate3d(0, 0, 0) rotate(0deg);
		}
	}
	&.upright {
		svg {
			transform: translate3d(0, 0, 0) rotate(45deg);
		}
	}
	&.right {
		svg {
			transform: translate3d(0, 0, 0) rotate(90deg);
		}
	}
`;
exports.ArrowIconSvg = (0, styled_components_1.withTheme)(({ face = "up", hoverDirection, relative }) => {
    return (react_1.default.createElement(Styled, { className: `arrow-wrap  ${face}`, hoverDirection: hoverDirection, relative: relative },
        react_1.default.createElement("svg", { viewBox: "0 0 13 13", fill: "none" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.58376 2.73002L2.37551 6.93827L1.66841 6.23116L6.7102 1.18937L7.06375 0.835814L7.41731 \n                    1.18937L12.6326 6.40469L11.9255 7.11179L7.5846 2.77087L7.73721 11.7916L6.73735 11.8085L6.58376 2.73002Z" }))));
});
//# sourceMappingURL=ArrowIconSvg.atom.js.map